import React from "react";
import { t } from "../../../../../../utils/i18n";

const SelectToken = ({ token, updateParent }) => (
  <div className="select-token">
    <h4 className="">{t("p2p.select_token.title")}</h4>
    <div className="tokens">
      <button
        className={`btn btn-light ${token === "USDT" ? "active" : "inactive"}`}
        onClick={() => updateParent("token", "USDT")}
      >
        <div className="font-1_4 pb-2"><strong>USD</strong> <span className="text-muted pt-1">{t("p2p.select_token.usd_name")}</span></div>
        
      </button>
    </div>
  </div>
);

export default SelectToken;
